// Passwordless (OTP) account auth — talks to metro-child/account-auth/auth.php
// (OTP) and the shared checkout password endpoint. WP wp_send_json_* envelope.

const cfg = (typeof window !== 'undefined' && window.ACCOUNT_AUTH) || {};

async function post(action, params, nonce) {
  const body = new URLSearchParams();
  body.set('action', action);
  body.set('nonce', nonce || '');
  Object.keys(params).forEach((k) => body.set(k, params[k] == null ? '' : params[k]));
  let json;
  try {
    const res = await fetch(cfg.ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    });
    json = await res.json();
  } catch (e) {
    return { ok: false, data: { message: 'Πρόβλημα σύνδεσης. Δοκίμασε ξανά.' } };
  }
  return { ok: !!(json && json.success), data: (json && json.data) || {} };
}

const nAcct = (cfg.nonces && cfg.nonces.acct) || '';
const nAuth = (cfg.nonces && cfg.nonces.auth) || '';

export const sendCode = (identifier) => post('cn_acct_send_code', { identifier }, nAcct);
export const verifyCode = (identifier, code) => post('cn_acct_verify_code', { identifier, code }, nAcct);
// Optional password fallback reuses the checkout endpoint (its own nonce).
export const passwordLogin = (identifier, password) => post('cn_password_login', { identifier, password }, nAuth);
